import axios from 'axios';
import urls from '@/settings/urls';



export const connectToOfficeRND = (data) =>{
  let requestOptions = {
    method: 'POST',
    url: urls.integrations.officernd.connect,
    data,
  };
  return axios(requestOptions)
    .then(res => res.data);
}
export const GetOfficeRNDConfigurations = (queries) => {
  let requestOptions = {
    method: 'GET',
    url: urls.integrations.officernd.configure_info,
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    params: queries,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const SaveOfficeRnDConfigurations = (queries) => {
  let requestOptions = {
    method: 'POST',
    url: urls.integrations.officernd.save_configure,
    data: queries,
  };

  return axios(requestOptions)
    .then(res => res.data);
}
export const UpdateOfficeRnDConfigurations = (queries) => {
  let requestOptions = {
    method: 'PUT',
    url: urls.integrations.officernd.save_configure + '/' + queries.id,
    data: queries,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetOfficeRnDConfig = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.office_rnd_config
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectOfficeRnDService = ({data, successHandler, errorHandler}) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.office_rnd_config,
    data: {
      officernd_configuration: data
    },
  };

  return axios(requestOptions)
    .then(res => res.data)
    .then(successHandler)
    .catch(errorHandler);
}


export const RemoveOfficeRnDService = () => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.office_rnd_config}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const ConnectOfficeRnDMembers = () => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.office_rnd_config + '/connect_members',
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CheckRunningStatusOfficeRnDMembers = (id) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.office_rnd_config + '/check_running_status',
    params: {
      progress_job_id: id
    },
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetDeskworksCenters = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.deskworks_centers
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const UpdateDeskworksCenters = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: urls.admin.deskworks_config,
    data: {
      deskworks_configuration: data
    },
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetDeskworksConfig = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.deskworks_config
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectDeskworksService = ({data, successHandler, errorHandler}) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.deskworks_config,
    data: {
      deskworks_configuration: data
    },
  };

  return axios(requestOptions)
    .then(res => res.data)
    .then(successHandler)
    .catch(errorHandler);
}

export const RemoveDeskworksService = () => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.deskworks_config}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectDeskworksMembers = () => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.deskworks_config + '/connect_members',
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CheckRunningStatusDeskworksMembers = (id) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.deskworks_config + '/check_running_status',
    params: {
      progress_job_id: id
    },
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetQuickbooksConfig = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.quickbooks_config
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectQuickbooksService = ({data, successHandler, errorHandler}) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.quickbooks_config,
    data: {
      quickbooks_configuration: data
    },
  };

  return axios(requestOptions)
    .then(res => res.data)
    .then(successHandler)
    .catch(errorHandler);
}

export const RemoveQuickbooksService = () => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.quickbooks_config}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectQuickbooksMembers = () => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.quickbooks_config + '/connect_members',
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CheckRunningStatusQuickbooksMembers = (id) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.quickbooks_config + '/check_running_status',
    params: {
      progress_job_id: id
    },
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetSystemIntegrationStatus = ({integration}) => {
  let requestOptions = {
    method: 'GET',
    url: urls.provider +`/${integration}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ToggleSystemIntegrationStatus = ({integration, status}) => {
  let requestOptions = {
    method: status ? 'PUT' : 'DELETE',
    url: urls.admin.client + '/enable_integration',
    data: {
      name: integration,
    },
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetNexudusConfig = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.nexudus_config
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectNexudusService = ({data, successHandler, errorHandler}) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.nexudus_config,
    data: {
      nexudus_configuration: data
    },
  };

  return axios(requestOptions)
    .then(res => res.data)
    .then(successHandler)
    .catch(errorHandler);
}

export const RemoveNexudusService = () => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.nexudus_config}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectNexudusMembers = () => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.nexudus_config + '/connect_members',
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CheckRunningStatusNexudusMembers = (id) => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.nexudus_config + '/check_running_status',
    params: {
      progress_job_id: id
    },
  }

  return axios(requestOptions)
    .then(res => res.data);
}
